import axios from "axios";
import { message } from "antd";
import { baseUrl } from "./env";

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

const resetToken = localStorage.getItem("verifyToken");

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMsg =
      error?.response?.data?.message ||
      error?.response?.data?.title ||
      "Something went wrong!";
    message.error(errorMsg);
    return Promise.reject(error);
  },
);

// HTTP utility methods
const http = {
  post: (path, body) => axiosInstance.post(path, body).then((res) => res.data),

  get: (path) => axiosInstance.get(path).then((res) => res.data),

  postFormData: (path, body) =>
    axiosInstance
      .post(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  put: (path, body) => axiosInstance.put(path, body).then((res) => res.data),

  putFormData: (path, body) =>
    axiosInstance
      .put(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),

  delete: (path) => axiosInstance.delete(path).then((res) => res.data),

  patch: (path, body) =>
    axiosInstance.patch(path, body).then((res) => res.data),

  resetPassword: (path, body) => {
    const resetToken = localStorage.getItem("verifyToken");
    return new Promise(async (resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${resetToken}`,
      };

      try {
        const res = await axios.post(`${baseUrl}/${path}`, body, { headers });
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  },

  patchFormData: (path, body) =>
    axiosInstance
      .patch(path, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data),
};

export default http;

// import axios from "axios";
// import { baseUrl } from "./env";

// // Utility function to retrieve the token (from localStorage)
// const getToken = localStorage.getItem("token") || "";
// // return storedToken ? JSON.parse(storedToken) : "";

// // HTTP utility
// const http = {
//   post: (path, body) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.post(`${baseUrl}${path}`, body, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//   get: (path) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.get(`${baseUrl}${path}`, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//   postFormData: (path, body) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.post(`${baseUrl}${path}`, body, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//   put: (path, body) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.put(`${baseUrl}${path}`, body, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//     putFormData: (path, body) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.put(`${baseUrl}${path}`, body, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//   delete: (path) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.delete(`${baseUrl}${path}`, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

//   patchFormData: (path, body) => {
//     return new Promise(async (resolve, reject) => {
//       const headers = {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${getToken}`,
//       };

//       try {
//         const res = await axios.patch(`${baseUrl}${path}`, body, { headers });
//         resolve(res.data);
//       } catch (err) {
//         reject(err);
//       }
//     });
//   },

// };

// axios.interceptors.res.use(
//   (res) => {

//     return res;
//   },
//   (err) => {
//     return Promise.reject(err);
//   }
// );

// export default http;
